/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TOTPRegisterAttestationData } from './TOTPRegisterAttestationData';
import {
    TOTPRegisterAttestationDataFromJSON,
    TOTPRegisterAttestationDataFromJSONTyped,
    TOTPRegisterAttestationDataToJSON,
    TOTPRegisterAttestationDataToJSONTyped,
} from './TOTPRegisterAttestationData';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface TOTPRegisterAttestation
 */
export interface TOTPRegisterAttestation {
    /**
     * 
     * @type {string}
     * @memberof TOTPRegisterAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof TOTPRegisterAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {TOTPRegisterAttestationData}
     * @memberof TOTPRegisterAttestation
     */
    data?: TOTPRegisterAttestationData;
}



/**
 * Check if a given object implements the TOTPRegisterAttestation interface.
 */
export function instanceOfTOTPRegisterAttestation(value: object): value is TOTPRegisterAttestation {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}

export function TOTPRegisterAttestationFromJSON(json: any): TOTPRegisterAttestation {
    return TOTPRegisterAttestationFromJSONTyped(json, false);
}

export function TOTPRegisterAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPRegisterAttestation {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': json['data'] == null ? undefined : TOTPRegisterAttestationDataFromJSON(json['data']),
    };
}

export function TOTPRegisterAttestationToJSON(json: any): TOTPRegisterAttestation {
    return TOTPRegisterAttestationToJSONTyped(json, false);
}

export function TOTPRegisterAttestationToJSONTyped(value?: TOTPRegisterAttestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'challenge_type': ChallengeTypeToJSON(value['challenge_type']),
        'data': TOTPRegisterAttestationDataToJSON(value['data']),
    };
}

